import StorageService from '@/utils/storage-service';
import StoreModuleService from '../StoreModuleService';
import { initialState, IS_MARKET_PLACE_EXACT_MATCH, MARKETPLACE_FILTER_BY_FEATURE_TYPE } from './state';

const storage = StorageService.getStorage();

export const SET_MARKETPLACE = 'SET_MARKETPLACE';
export const SET_IS_MARKETPLACE_EXACT_MATCH = 'SET_IS_MARKETPLACE_EXACT_MATCH';
export const SET_MARKETPLACE_FILTER_BY_FEATURE_TYPE = 'SET_MARKETPLACE_FILTER_BY_FEATURE_TYPE';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_MARKETPLACE](state, marketplace) {
		state.marketplace = marketplace;
	},
	[SET_IS_MARKETPLACE_EXACT_MATCH](state, isMarketplaceExactMatch) {
		storage.setItem(IS_MARKET_PLACE_EXACT_MATCH, isMarketplaceExactMatch);
		state.isMarketplaceExactMatch = isMarketplaceExactMatch;
	},
	[SET_MARKETPLACE_FILTER_BY_FEATURE_TYPE](state, marketplaceFilterByFeatureType) {
		storage.setItem(MARKETPLACE_FILTER_BY_FEATURE_TYPE, marketplaceFilterByFeatureType);
		state.marketplaceFilterByFeatureType = marketplaceFilterByFeatureType;
	},
};

export default mutations;
